export default {
  SettingBaseDataCountry: {
    addCountry: 'Add Country',

    table: {
      countryCode: 'Country Code',
      countryName: 'Country Name',
      abbreviation: 'Abbreviation',
      countryAbbreviation: 'Country Abbreviation',
      countryCodeText: 'Please enter country code',
      countryNameText: 'Please enter country name',
      editCountryDefinition: 'Edit Country Definition',
      addCountryDefinition: 'Create Country Definition',
    }
  }
};
